import React, { useState } from "react";
import img1 from "../images/banner.jpg";
import cakeimg1 from "../images/pasteries-removebg-preview.png"
import cakeimg4 from "../images/brownie.png"
import cakeimg5 from "../images/puffs.png"
import cakeimg6 from "../images/pizzas-removebg-preview.png"
import cakeimg7 from "../images/burgers-removebg-preview.png"
import cakeimg8 from "../images/sand.jpeg"
import cakeimg9 from "../images/frenchfries.png"
import cakeimg10 from "../images/moktails-removebg-preview.png"
import cakeimg11 from "../images/milkshakes-removebg-preview.png"
import cakeimg12 from "../images/combo1.png"
import cakeimg13 from "../images/icecreams.png"
import cakeimg14 from "../images/juices-removebg-preview.png"
import cakeimg15 from "../images/pastrycombo.png"
import cakeimg16 from "../Sevendays Bakery/cakeimg (16).jpg"
import { NavLink } from "react-router-dom";

const products = [
{ id: 17, name: "Cakes", image: cakeimg16 },
  { id: 1, name: "Pastries Paradise", image: cakeimg1 },
  { id: 2, name: "Choco Blis Bites", image: cakeimg4 },
  { id: 3, name: "Golden Layers", image: cakeimg5 },
  { id: 4, name: "The Pizza Pallete", image: cakeimg6 },
  { id: 5, name: "The Burger Carft", image: cakeimg7 },
  { id: 6, name: "The Sandwich Club", image: cakeimg8 },
  { id: 7, name: "Crispy Corner", image: cakeimg9 },
  { id: 11, name: "Mocktail Magic", image: cakeimg10 },
  { id: 12, name: "Shake Heaven", image: cakeimg11 },
  { id: 13, name: "The Feast Combo", image: cakeimg12 },
  { id: 14, name: "Frosted Delights", image: cakeimg13 },
  { id: 15, name: "Beverages", image: cakeimg14 },
  { id: 16, name: "Frost & Fizz Mellow Magic Combo", image: cakeimg15 },
]

const OurProducts = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="products-section" id="products">
      <h2>Our Products</h2>
      <div className="productlist-grid">
        {products.map((item) => (
          <div
            className="product-card"
        
          >
            <NavLink to={`/productlist/${item.id}`}>
              <img  className="product-image" src={item.image} alt={item.name} />
              <h4 className="product-name">{item.name}</h4>
            </NavLink>
   <a
              href={`https://wa.me/919666696905?text=Hi, I would like to order: ${encodeURIComponent(item.name)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-order-btn"
            >
              Order Now via WhatsApp
            </a>

          </div>
        
        ))}
      </div>

      {/* Modal View */}
      {/* {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal content
          >
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              &times;
            </button>
            <img src={selectedImage} alt="Large view" className="modal-img" />
          </div>
        </div>
      )} */}
    </section>
  );
};

export default OurProducts;
